import { createContext } from 'react';
import { SecuritiesSecurity } from '../type';

export const securitiesSecurityParamsContext = createContext<Partial<SecuritiesSecurity>>({});
